import { Context } from "@nuxt/types/app";
import { cloneDeep, get } from "lodash-es";

import { getFilteredMenu } from "./hooks/ui.filteredMenu.hook";

import { SideBarMenu } from "@/shared/models/menu.model";
import { EmployeeBenefitPermission } from "@/src/employee-benefit/permission";
import { useEmployeeBenefitMenu } from "@/src/employee-benefit/shared/hooks/employee-benefit-menu";

interface SidebarMenuVisibility {
  defineSidebarMenuVisibility(
    menus: Record<string, any>[],
  ): Record<string, any>[];
}

export default function (context: Context): SidebarMenuVisibility {
  function defineSidebarMenuVisibility(
    menus: Record<string, any>[],
  ): Record<string, any>[] {
    const tempMenus: Record<string, any>[] = cloneDeep(menus);

    const tempSidebarMenu: Record<string, any>[] =
      get(context.app, `store.getters['appPersisted/getSidebarMenu']`) !== ""
        ? JSON.parse(
            get(context.app, `store.getters['appPersisted/getSidebarMenu']`),
          )
        : [];

    if (!tempSidebarMenu.length) {
      const filteredMenu = getFilteredMenu(context, tempMenus);
      // remove { isProductCategory: true }
      let resultMenu = filteredMenu.filter(
        (item: Record<string, any>) => !item.isProductCategory,
      );

      const permission = EmployeeBenefitPermission(context);
      const sideBarWithEmployeeBenefitMenu = useEmployeeBenefitMenu(
        resultMenu as Array<SideBarMenu>,
        permission,
      );
      resultMenu = sideBarWithEmployeeBenefitMenu;

      // also save the resultMenu in persist store (default)
      if (context && context.app && context.app.store) {
        context.app.store.dispatch(
          "appPersisted/setSidebarMenuDefault",
          JSON.stringify(resultMenu),
        );
      }

      return resultMenu;
    }

    // if sidebarMenu persist exist
    return tempSidebarMenu;
  }

  return { defineSidebarMenuVisibility };
}
